<template>
  <div class="modal fade" id="modal-stock-movements" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Mouvements de Stock - {{ product?.name }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"/>
        </div>
        <div class="modal-body">
          <table class="table table-bordered text-nowrap border-bottom table-hover">
            <thead class="border-top success02">
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Quantité</th>
              <th>Source</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!movements.length">
              <td colspan="4" class="text-muted">Aucun mouvement trouvé</td>
            </tr>
            <tr v-for="(mvt, index) in movements" :key="index">
              <td>{{ formatDate(mvt.date) }}</td>
              <td>
                  <span :class="['badge', mvt.type === 'ENTREE' ? 'bg-success' : 'bg-danger']">
                    {{ mvt.type }}
                  </span>
              </td>
              <td>{{ mvt.quantity }}</td>
              <td>{{ mvt.source || '-' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalStockMovements",
    props: {
      product: Object,
      movements: Array
    },
    methods: {
      formatDate(dateStr) {
        const d = new Date(dateStr);
        return d.toLocaleString();
      }
    }
  };
</script>
